import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import DataTable, { MUIDataTableOptions } from "mui-datatables";
import * as Dati from "../../../Dati";
import { _TableLoader } from "..";
import { GetBindersListColumns } from "./BindersListColumns";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    tableWrapper: {
        marginTop: spacing(4),
        position: "relative"
    }
}));

interface IBindersListTableProps {
    Data: Dati.CRisAPIPagineBinder | undefined;
    Options: MUIDataTableOptions;
    IsLoading: boolean;
}

export const _BindersListTable: React.FC<IBindersListTableProps> = React.memo(({ Data, Options, IsLoading }) => {
    const classes = useStyles();

    return (
        <Box className={classes.tableWrapper}>
            {IsLoading && <_TableLoader />}
            <DataTable title="" data={Data?.Dati || []} columns={GetBindersListColumns()} options={Options} />
        </Box>
    );
});



// WEBPACK FOOTER //
// ./src/inar2/components/BindersList/BindersListTable.tsx